module.exports = "/packs/careerchange_survey-sp-d2dbe4105379045bd9fa813b6d7d341d.jpg";